import { useState, useEffect } from "react";

export function useIsVisible(ref){
    // custom hook to check if an element referenced by 'ref' 
    // is visible, i.e. intersects with viewport
    // ref: a useRef reference to the element 
    const [isIntersecting, setIsIntersecting] = useState(false); 
    
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsIntersecting(entry.isIntersecting); 
            console.log(entry.isIntersecting)
        })
        observer.observe(ref.current); 

        return () => {
            observer.disconnect(); 
        }
    }, [ref])

    return isIntersecting; 
}